import React from 'react';
import PropTypes from 'prop-types';

import { Link } from 'react-router';
import displayName from 'component-lib/displayName';

import joinElements from '../../../lib/joinElements';

import styles from './style.scss';

const DIVIDER = ' / ';

export default function Breadcrumb({ nodes }) {
    const elements = nodes.map((node) => {
        if (node.empty) {
            return <noscript />;
        }

        const wrapProps = {
            className: styles.link,
            'data-breadcrumb': node.routeName,
            ...Object.keys(node).reduce((_all, key) => {
                const all = _all;

                if (key.indexOf('data-') === 0) {
                    all[key] = node[key];
                }

                return all;
            }, {}),
        };

        const wrap = child => (
            <span {...wrapProps}>
                {child}
            </span>
        );

        if (node.onClick) {
            return wrap(<a role="presentation" onClick={node.onClick} data-action="breadcrumb">
                {node.text}
            </a>,);
        }

        return wrap(<Link data-action="breadcrumb" to={node.to}>
            {node.text}
        </Link>,);
    },);

    return (
        <div>
            {joinElements(elements, <span className={styles.divider}>
                {DIVIDER}
            </span>)}
        </div>
    );
}

Breadcrumb.displayName = displayName('Navigation/Breadcrumb');

Breadcrumb.propTypes = {
    nodes: PropTypes.array.isRequired,
};
